import React from "react";
import { Tooltip } from "antd5";

import { useDeleteRecordQualification } from "../../lib/hooks/api/records/useDeleteRecordQualification";
import Button from "../ui/button/Button";

type Props = {
  notice: {
    id: string;
    score: number | null | undefined;
    signalTypes: Record<string, string[]> | undefined;
    procurementStage: { id: string; stage: string };
  };
  contextSource: string;
  size?: "small" | "default";
};

export function RestoreNoticeButton({ notice, size = "default", contextSource }: Props) {
  const { mutate } = useDeleteRecordQualification();
  return (
    <Tooltip title={size === "small" ? "Restore notice" : null}>
      <Button
        onClick={() =>
          mutate({
            contextSource,
            recordGuid: notice.id,
            score: notice.score,
            procurementStage: notice.procurementStage,
            signalTypes: notice.signalTypes,
          })
        }
        icon="refreshCcw01"
        buttonType="secondary"
      >
        {size === "default" ? "Restore" : null}
      </Button>
    </Tooltip>
  );
}
